<div class="filter-table">
  @switch (app.filterTable.getFilterType(fieldId)) {
    @case ('options') {
      <div>
        <div class="input-group-btn">
          <div
            class="dropdown"
        [ngClass]="{
          'background-color':
            searchWords[column] != null && searchWords[column] !== ''
        }"
            >
            <input
              class="form-control dropdown-filter dropdown-toggle"
              data-bs-toggle="dropdown"
              [(ngModel)]="searchWords[column]"
              placeholder="{{ app.text.RM.filter }}"
              onkeydown="return false"
          (click)="
            app.filterTable.isDropdownOpen = true;
            app.filterTable.filterFocus = true
          "
              />
            @if (searchWords[column]) {
              <button class="btn clear-dropdown">
                <i class="fa fa-times icon-size" (click)="clearFilter(column)"></i>
              </button>
            }
            <div class="dropdown-menu dropdown-list">
              @for (option of app.filterTable.getOptions(fieldId); track option) {
                <div>
                  @if (!app.filterTable.getOptionsAsValue(column)) {
                    <span
                      class="dropdown-item"
              (click)="
                searchWords[column] = app.filterTree.getOptionText(
                  fieldId,
                  option
                );
                onChange(column);
                saveFilterInput(column);
                app.filterTable.isDropdownOpen = false
              "
                      >
                      {{ app.filterTree.getOptionText(fieldId, option) }}
                    </span>
                  }
                  @if (app.filterTable.getOptionsAsValue(column)) {
                    <span
                      class="dropdown-item"
              (click)="
                searchWords[column] = option;
                onChange(column);
                saveFilterInput(column);
                app.filterTable.isDropdownOpen = false
              "
                      >
                      {{ option }}
                    </span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    @default {
      <div>
        <div
          class="input-group"
      [ngClass]="{
        'background-color':
          searchWords[column] != null && searchWords[column] !== ''
      }"
          >
          <input
            type="text"
            class="form-control input-filter"
            placeholder="{{ app.text.RM.filter }}"
            [(ngModel)]="searchWords[column]"
            (input)="onChange(column)"
            placeholder="{{ app.text.RM.filter }}"
            on-focusout="saveFilterInput(column)"
        (click)="
          app.filterTable.isDropdownOpen = false;
          app.filterTable.filterFocus = true
        "
            />
          @if (searchWords[column]) {
            <span
              class="input-group-text clearIcon"
              id="basic-addon2"
              (click)="clearFilter(column)"
              ><i class="fa fa-times"></i
            ></span>
          }
        </div>
      </div>
    }
  }
</div>
